<mat-card flex="100">
  <mat-card-title class="title-section">
    {{ (airCarrier$ | async).abbreviation }} Pilots
    <button mat-raised-button routerLink="add" mat-button class="add-pilot-button">
      <mat-icon>add</mat-icon>Add Pilot
    </button>
    <button mat-raised-button (click)="refresh()">
      <mat-icon>refresh</mat-icon>
    </button>
  </mat-card-title>
  <mat-divider></mat-divider>
  <mat-card-content>
    <div
      fxLayout="row wrap"
      fxLayoutGap="10px"
      fxLayoutAlign="start center"
      [formGroup]="pilotParameters"
    >
      <mat-form-field>
        <input matInput formControlName="searchTerm" placeholder="Search" />
        <button
          mat-button
          *ngIf="pilotParameters.controls.searchTerm.value"
          matSuffix
          mat-icon-button
          aria-label="Clear"
          (click)="pilotParameters.controls.searchTerm.reset()"
        >
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>
      <mat-checkbox formControlName="includeHiddenOnly">Show hidden only?</mat-checkbox>
    </div>
    <table
      mat-table
      *tdLoading="
        'pilots-table';
        mode: 'indeterminate';
        type: 'circle';
        strategy: 'overlay';
        color: 'primary'
      "
      [dataSource]="pilots$"
      fxFlex="100"
    >
      <ng-container matColumnDef="firstName">
        <th mat-header-cell *matHeaderCellDef>First Name</th>
        <td mat-cell *matCellDef="let pilot">
          <a routerLink="{{ pilot.id }}" class="link-text">
            {{ pilot.firstName }}
          </a>
        </td>
      </ng-container>
      <ng-container matColumnDef="middleName">
        <th mat-header-cell *matHeaderCellDef>Middle Name</th>
        <td mat-cell *matCellDef="let pilot">
          <a routerLink="{{ pilot.id }}" class="link-text">
            {{ pilot.middleName }}
          </a>
        </td>
      </ng-container>
      <ng-container matColumnDef="lastName">
        <th mat-header-cell *matHeaderCellDef>Last Name</th>
        <td mat-cell *matCellDef="let pilot">
          <a routerLink="{{ pilot.id }}" class="link-text">
            {{ pilot.lastName }}
          </a>
        </td>
      </ng-container>
      <ng-container matColumnDef="certificateNumber">
        <th mat-header-cell *matHeaderCellDef>Certificate Number</th>
        <td mat-cell *matCellDef="let pilot">
          {{ pilot.certificateNumber }}
        </td>
      </ng-container>
      <ng-container matColumnDef="processingState">
        <th mat-header-cell *matHeaderCellDef>Processing State</th>
        <td mat-cell *matCellDef="let pilot">
          {{ pilot.processingState | humanize }}
        </td>
      </ng-container>
      <ng-container matColumnDef="lastProcessedDate">
        <th mat-header-cell *matHeaderCellDef>Last Processed Date</th>
        <td mat-cell *matCellDef="let pilot">
          {{ (pilot.lastProcessedDate | date: 'MM/dd/yyyy HH:mm') || '--' }}
        </td>
      </ng-container>
      <ng-container matColumnDef="processingError">
        <th mat-header-cell *matHeaderCellDef>Processing Error</th>
        <td mat-cell *matCellDef="let pilot" class="prd-processing-error-text">
          {{ pilot.processingError }}
        </td>
      </ng-container>
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef>Actions</th>
        <td mat-cell *matCellDef="let pilot">
          <button mat-icon-button [matMenuTriggerFor]="pilotActions">
            <mat-icon>more_vert</mat-icon>
          </button>
          <mat-menu #pilotActions="matMenu">
            <a mat-menu-item routerLink="{{ pilot.id }}"> <mat-icon>assignment</mat-icon>View </a>
            <a mat-menu-item routerLink="{{ pilot.id }}/edit"> <mat-icon>edit</mat-icon>Edit </a>
            <a mat-menu-item (click)="bulkUpdate(pilot.id)">
              <mat-icon>list</mat-icon>Update Entities Processing State
            </a>
            <a mat-menu-item (click)="delete(pilot)"> <mat-icon>delete</mat-icon>Delete </a>
          </mat-menu>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
    <mat-paginator
      [pageSize]="pageSize$ | async"
      [pageIndex]="pageIndex$ | async"
      [pageSizeOptions]="pageSizeOptions"
      [length]="total$ | async"
      (page)="onPage($event)"
    >
    </mat-paginator>
  </mat-card-content>
</mat-card>
